import { render, staticRenderFns } from "./ContactTile.vue?vue&type=template&id=2d8bd3ec&"
import script from "./ContactTile.vue?vue&type=script&lang=js&"
export * from "./ContactTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports